export default {
  header: 'BUZZZZZZZZZ',
  headerLabel: 'What\'s the buzz?',
  quotes: [
    {
      id: 'new_york_times',
      quote: '“Materials and details are thoughtful, and the clothes are wildly cute.”',
      name: 'The New York Times'
    },
    {
      id: 'today_show',
      quote: '“The clothing is so stylish and so affordable...and the softest quality.”',
      name: 'Today Show'
    },
    {
      id: 'people_magazine',
      quote: '“They\'ll be at the top of their playground game with these clothes.”',
      name: 'People Magazine'
    },
    {
      id: 'tech_crunch',
      quote: '“Rockets of Awesome is a total no brainer.”',
      name: 'Tech Crunch'
    },
    {
      id: 'fast_company',
      quote: '“Shopping for kids’ clothes can be fun.”',
      name: 'Fast Company'
    },
    {
      id: 'parents_magazine',
      quote: '“You can’t buy these clothes in stores.”',
      name: 'Parent\'s Magazine'
    },
    {
      id: 'la_times',
      quote: '“Obsessively kid friendly.”',
      name: 'The L.A. Times'
    },
    {
      id: 'new_york_post',
      quote: '“The witty graphics, throwback bombers and metallic-accented tutus from this fashion-forward label are all about encouraging kids \'to be their authentic selves.\'',
      name: 'The New York Post'
    }
  ],
}



// WEBPACK FOOTER //
// ./src/components/pressQuotes/defaultProps.js